export default "__VITE_ASSET__ofCYTTdY__"